export default "__VITE_ASSET__BJyQvgdJ__"